// extracted by mini-css-extract-plugin
export default {"container":"user-chat-message_container__Q7yQM","message":"user-chat-message_message__evmM4"};